import { useLayoutEffect, type RefObject } from 'react';

/**
 * Maße des Gerüsts als CSS-Variablen am Rahmen, für Seiten aus der Zeit vor dem Rahmen:
 * `--shell-viewport` ist die sichtbare Höhe des scrollenden Inhalts (statt `100dvh` für
 * klebende Spalten), `--shell-bottom-bar` die Höhe der Handy-Leiste unten (für feste Leisten,
 * die über ihr stehen müssen). Ohne ResizeObserver folgen die Werte der Fenstergröße.
 */
export function useShellMetrics(
  frame: RefObject<HTMLElement | null>,
  main: RefObject<HTMLElement | null>,
  bottomBar: RefObject<HTMLElement | null>,
): void {
  useLayoutEffect(() => {
    const root = frame.current;
    if (!root) return;
    const update = () => {
      root.style.setProperty('--shell-viewport', `${main.current?.clientHeight ?? 0}px`);
      root.style.setProperty('--shell-bottom-bar', `${bottomBar.current?.offsetHeight ?? 0}px`);
    };
    update();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', update);
      return () => window.removeEventListener('resize', update);
    }
    const observer = new ResizeObserver(update);
    if (main.current) observer.observe(main.current);
    if (bottomBar.current) observer.observe(bottomBar.current);
    return () => observer.disconnect();
  });
}
